import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import FilterChips from "./FilterChips";
import { STATUS_ORDER, statusCountCode, statusText, statusTone } from "./questionStatus";

const rank = (code) => {
  const index = STATUS_ORDER.indexOf(code);
  return index === -1 ? STATUS_ORDER.length : index;
};

/**
 * Status filter of a question list: "All" and one chip per status, in the order a question goes through
 * them, each with its count (`counts` = GET status_count/ without the status filter). `selected` is a
 * status uuid or "all"; a click on the selected chip goes back to all. Drafts are only listed with
 * `showDraft` (My Questions): the bank does not list them, so they are not in its "All" either.
 */
export default function StatusFilterBar({ counts, statusOptions = [], selected, onSelect, showDraft = false }) {
  const [t] = useTranslation();
  const items = useMemo(() => {
    const codeByUuid = new Map(statusOptions.map((o) => [o.uuid, o.code]));
    return (Array.isArray(counts) ? counts : [])
      .map((s) => ({ uuid: s.status_uuid, name: s.status, count: s.count || 0, code: statusCountCode(s, codeByUuid) }))
      .filter((s) => s.uuid && (s.code !== "DRAFT" || showDraft || s.uuid === selected))
      .sort((a, b) => rank(a.code) - rank(b.code));
  }, [counts, statusOptions, showDraft, selected]);

  if (!items.length) return null;
  const total = items.filter((s) => showDraft || s.code !== "DRAFT").reduce((sum, s) => sum + s.count, 0);

  return (
    <FilterChips
      label={t("question_list.status_filter")}
      allLabel={t("question_list.status_all")}
      allCount={total}
      items={items.map((s) => ({ value: s.uuid, label: statusText(t, s.code, s.name), count: s.count, tone: statusTone(s.code) }))}
      selected={selected}
      onSelect={onSelect}
    />
  );
}
